/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { InsuranceProviderPlanDetailViewModel } from './InsuranceProviderPlanDetailViewModel'; 

export function getInsuranceProviderPlanDetailOptions(id: string, onSuccess?: (result: InsuranceProviderPlanDetailViewModel) => void) {
	return queryOptions({
		queryKey: ['insurance-provider-plan-detail', id],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/libraries/insuranceproviders/queries/getinsuranceproviderplandetail/' + id;
			const resp = await axios.get<InsuranceProviderPlanDetailViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(id)
	});
}